"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderMessageBarActions_unstable", {
    enumerable: true,
    get: function() {
        return renderMessageBarActions_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _reactbutton = require("@fluentui/react-button");
const renderMessageBarActions_unstable = (state, contexts)=>{
    (0, _reactutilities.assertSlots)(state);
    if (state.layout === 'multiline') {
        return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_reactbutton.ButtonContextProvider, {
            value: contexts.button,
            children: [
                state.containerAction && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.containerAction, {}),
                /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {})
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_reactbutton.ButtonContextProvider, {
        value: contexts.button,
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {}),
            state.containerAction && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.containerAction, {})
        ]
    });
};
